export class BacklogReportsTextCopy {

  public static value = `expected revenue tied up in backlog (approx. annual revenue from contested PCNs
    (given in Policies), divided by 365 (days), multiplied by average backlog days)`;
  public static wkgDays = `working days`;
  public static calDays = `calendar days`;
  public static change = `the increase/decrease in response days compared with the previous
    period (a minus number shows an improvement)`;

}
